import { CtaBtnAlignment } from '@nextgen-web-framework/all';
import { ImageWithOptionalCTAPropType } from '../../../components/ImageWithOptionalCTA/types/propsTypes';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
import { CTAType } from '../../../components/ImageWithOptionalCTA/types/enum';

const transformImageWithOptionalCTA = (props: CMSTransformerDataType): ImageWithOptionalCTAPropType => {
  const imageTransformedProps = Array.isArray(props?.image_with_optional_cta)
    ? props?.image_with_optional_cta[0]
    : props?.image_with_optional_cta;

  let payload: ImageWithOptionalCTAPropType = {
    componentType: ComponentType.image_with_optional_cta,
    rounded: false,
    bgColor: 'transparent',
    config: { rounded: false, width: 100 },
    imgList: [{ alt: '', image_file: {}, viewport: [], _metadata: {} }],
    link: {},
  };
  if (imageTransformedProps?.image) {
    const {
      cta,
      image: { images },
      // required when other properties are available.
      // ...restImageConfig
    } = imageTransformedProps;
    const { type, button_title, url, target, ...restProps } = cta;
    payload = {
      ...payload,
      imgList: images,
      link: {
        url: url,
        target: target,
      },
    };
    payload.button = {
      ...restProps,
      alignment: CtaBtnAlignment.BOTTOM_CENTER,
      borderDistance: 24,
      title: type === CTAType.IMAGE || type === CTAType.NONE ? '' : button_title,
    };
  }
  return payload;
};
export default transformImageWithOptionalCTA;
